import logoWhite from '../../static/logo-sds-white.png';
import './Footer.scss';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <div className='footer__content__logo'>
            <img src={logoWhite} alt="Logo SDS Detailing Cleaning LLC" />
          </div>

          <div className="footer__content__items">
            <p>&copy; 2026 SDS Detailing Cleaning LLC. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;